import { FC } from 'react'
import { IGlassPanel } from 'types/ui/glassPanel.interface'
import { StyledGlassPanel } from './GlassPanel.styled'

export const GlassPanel: FC<IGlassPanel> = ({ children, ...rest }) => {
  return <StyledGlassPanel {...rest}>{children}</StyledGlassPanel>
}
